module.exports = __webpack_public_path__ + "img/consignments_dark.6beb8589.svg";